import {inject, observer} from 'mobx-react';
import React, {Component} from 'react';

import {discoveryTracker} from '@udemy/browse-event-tracking';
import {TrackingContextProvider} from '@udemy/event-tracking';
import {DiscoveryUnitsContainerStore} from '@udemy/react-discovery-units';
import {WindowShoppingCard} from '@udemy/react-discovery-units';
import {CourseCardSkeletonGroup} from '@udemy/react-reveal-components';
import {UDData, withUDData} from '@udemy/ud-data';

import {CardContainerStore, CardContainerUnit} from './card-container.mobx-store';
import styles from './card-container.module.less';

interface CardContainerProps {
    unit: CardContainerUnit;
    className?: string;
    cardProps?: Record<string, unknown>;
    // injected
    discoveryUnitsStore?: DiscoveryUnitsContainerStore;
    udData?: UDData;
}

@inject('discoveryUnitsStore')
@observer
class InternalCardContainer extends Component<CardContainerProps> {
    private store: CardContainerStore;

    constructor(props: CardContainerProps) {
        super(props);
        const {discoveryUnitsStore, unit, udData} = this.props;
        const pageType = discoveryUnitsStore ? discoveryUnitsStore.pageType : '';
        this.store = new CardContainerStore(pageType, unit, udData);
    }

    componentDidMount() {
        if (!this.store.unit.items.length) {
            this.store.fetchUnit({pageSize: 6});
        }
    }

    render() {
        const {className, cardProps} = this.props;

        if (!this.store.unit.items.length && this.store.loading) {
            return (
                <CourseCardSkeletonGroup
                    rowCount={3}
                    size="small"
                    cardCountPerRow={2}
                    style={{width: '100%', height: '150px'}}
                />
            );
        }

        return (
            <div className={`${className ?? ''} ${styles.container}`}>
                {this.store.unit.items.map((course, i) => (
                    <TrackingContextProvider
                        key={course.id}
                        trackingContext={{
                            trackImpressionFunc: discoveryTracker.trackDiscoveryImpression,
                            index: i,
                            backendSource: this.store.backendSource,
                        }}
                    >
                        <WindowShoppingCard
                            course={course}
                            trackingClickCallbackFunc={() =>
                                discoveryTracker.trackDiscoveryItemClickEvent(
                                    {item: course},
                                    {backendSource: this.store.backendSource, index: i},
                                )
                            }
                            {...cardProps}
                        />
                    </TrackingContextProvider>
                ))}
            </div>
        );
    }
}

export const CardContainer = withUDData(InternalCardContainer) as React.ComponentType<
    Omit<CardContainerProps, 'udData' | 'discoveryUnitsStore'>
>;
